export default __webpack_public_path__ + "static/media/butterfly.af6cbdd0.webp";